import { combineReducers } from "redux";

import loginReducer from "./LoginReducer";
import operationReducer from "./OperationReducer";
import dashboardReducer from "./DashboardReducer";
const appReducer = combineReducers({
  loginReducer,
  operationReducer,
  dashboardReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
